import { render } from "./TemplateAdminView.vue?vue&type=template&id=028a3874"
import script from "./TemplateAdminView.vue?vue&type=script&lang=js"
export * from "./TemplateAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__